import { useForm } from "react-hook-form";
//primereact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { useState } from "react";

import { useNavigate } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import NumberInput from "../../../../../../../components/input/NumberInput";
import { getParcelsLate } from "../../../../../../../services/Parcel/getParcelsLate";
import { useQuery } from "react-query";
import { formatCurrency } from "../../../../../../../utils/formatCurrency";
import { formatDate } from "../../../../../../../utils/formatDate";
import { postSendExtrajudicial } from "../../../../../../../services/Contracts/IbJuridico/postSendExtrajudicial";
import { useAppContext } from "../../../../../../../context/AppContext";

const ModalSendIbJuridico = ({ visible, setVisible, idSale, enterpriseId, location }) => {
    const form = useForm();
    const navigate = useNavigate();
    const { permissions } = useAppContext();

    const { data: installmentsLate, isLoading: isLoadingInstallments } = useQuery({
        queryKey: [`installmentsLate${idSale}`],
        queryFn: () => getParcelsLate(idSale),
        enabled: !!permissions?.includes("62")
    });

    // console.log(installmentsLate)

    const errors = form.formState.errors;
    const [loading, setLoading] = useState(false);
    //COLUNAS DA TABELA
    const columns = [
        { field: "id", header: "ID" },
        { field: "sequence_number", header: `N° Parcela` },
        {
            field: "description",
            header: `Descrição`,
            body: (rowData) => rowData.description.name,
        },
        {
            field: "value",
            header: "Valor Parcela",
            body: (rowData) => formatCurrency(rowData.value),
        },
        {
            field: "due_date",
            header: "Data Vencimento",
            body: (rowData) => formatDate(rowData.due_date),
        },
    ];


    const sendSubmit = async (data) => {
        setLoading(true)
        const notification = toast.loading("Por favor, aguarde... os dados estão sendo enviados!");

        try {
            let obj = { sale_id: idSale, attorneys_fees: data.attorneys_fees };
            await postSendExtrajudicial(obj);
            setLoading(false);
            setVisible(false)
            toast.update(notification, {
                render: "Dados enviados com sucesso!",
                type: "success",
                isLoading: false,
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        } catch (error) {
            setLoading(false);
            setVisible(false)

            const errorMessage = error.error || "Houve um erro ao enviar os dados!";
            const additionalMessage = error.message ? ` ${error.message}` : "";

            toast.update(notification, {
                render: `${errorMessage} ${additionalMessage}`,
                type: "error",
                isLoading: false,
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    };



    // Função de confirmação personalizada
    function confirm(data) {

        if (installmentsLate.length === 0) {
            return toast.warning("Contrato sem parcelas a serem enviadas.")
        }

        confirmDialog({
            message: (
                <div style={{
                    color: '#a94442',
                    backgroundColor: '#f2dede',
                    padding: '10px',
                    borderRadius: '5px',
                    textAlign: 'center'
                }}>
                    Deseja enviar o contrato para cobrança extrajudicial?
                </div>
            ),
            header: (
                <div
                >
                    Confirmação
                </div>
            ),
            icon: "pi pi-exclamation-triangle",
            acceptLabel: "Sim",
            rejectLabel: "Não",
            accept: () => sendSubmit(data),
            acceptButtonStyle: {
                backgroundColor: '#d9534f',
                color: 'white',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '5px',
                cursor: 'pointer'
            },
            rejectButtonStyle: {
                backgroundColor: '#f2dede',
                color: '#a94442',
                border: 'none',
                padding: '8px 16px',
                borderRadius: '5px',
                cursor: 'pointer'
            },
            style: {
                border: '2px solid #d9534f',
                borderRadius: '5px'
            }
        });
    }


    const getFormErrorMessage = (name) => {
        return errors[name] ? (
            <small className="p-error">{errors[name].message}</small>
        ) : (
            <small className="p-error">&nbsp;</small>
        );
    };

    return (
        <>
            <Dialog
                header="Enviar para Cobrança Extrajudicial"
                id="modal_cad"
                className="rounded-4 shadow-lg"
                onHide={() => setVisible(false)}
                visible={visible}
                style={{
                    width: window.innerWidth <= 992 ? "85vw" : "70vw",
                    // padding: "20px",
                    // borderRadius: "10px",
                    // backgroundColor: "#f9f9f9"
                }}
            >
                <hr />
                <form onSubmit={form.handleSubmit(confirm)}>
                    <div className="row d-flex align-items-center mb-4">
                        <div className="col-md-8 mb-3">
                            <NumberInput
                                name="attorneys_fees"
                                suffix="%"
                                placeholder="0%"
                                required={true}
                                max={100}
                                minFractionDigits={2}
                                maxFractionDigits={2}
                                label="Taxa de Honorários"
                                control={form.control}
                                errors={errors}
                                getFormErrorMessage={getFormErrorMessage}
                                style={{ width: "100%" }}
                                className="p-inputtext-lg"
                            />
                        </div>
                        <div className="col-md-4 text-end">
                            <Button
                                loading={loading}
                                type="submit"
                                label="Enviar"
                                className="p-button p-component p-button-rounded"
                                style={{
                                    width: "100%",
                                    padding: "10px",
                                    fontSize: "16px",
                                }}
                            />
                        </div>
                    </div>
                    <hr />
                    <div className="px-2 pb-3">
                        <h5 className="text-muted mb-3">Parcelas Atrasadas</h5>
                        <DataTable
                            stripedRows
                            value={installmentsLate}
                            showGridlines
                            sortMode="multiple"
                            selectionMode="single"
                            rowsPerPageOptions={[5, 25, 100]}
                            emptyMessage="Nenhuma Informação foi encontrada."
                            scrollable
                            scrollHeight="300px"
                            className="datatable-custom"
                            style={{
                                minWidth: '100%',
                                border: "1px solid #ddd",
                                borderRadius: "10px"
                            }}
                        >
                            {columns.map((col, i) => (
                                <Column
                                    sortable
                                    body={col.body}
                                    key={i}
                                    style={{ minWidth: 150, padding: '10px' }}
                                    field={col.field}
                                    header={col.header}
                                    headerStyle={{
                                        backgroundColor: "#f1f1f1",
                                        fontWeight: "bold",
                                        textAlign: "center"
                                    }}
                                    className="p-column-header"
                                />
                            ))}
                        </DataTable>
                    </div>
                </form>
            </Dialog>


        </>
    );
};

export default ModalSendIbJuridico;
